<template>
    <div class="help-center-content">
        <h4>主播等级</h4>
        <p class="title">1.	什么是主播等级？</p>
        <p class="content">主播等级是喜马拉雅对主播的评估，维度包括内容质量和收益情况。</p>
        <p class="title">2. 怎么才能拥有主播等级？</p>
        <p class="content">通过实名认证即可至V0；再上传三条声音即可升级至V1（每条声音都要大于1分钟哦）
            <br>升级至V1后，就正式进入等级体系啦，会获得尊贵等级标识哦！</p>
        <p class="title">3.	怎么才能升级呢？</p>
        <p class="content">当有人在喜马拉雅完整收听你的节目或者获得收入，就可以获得等级分。等级分达到升级所需分值，就可以升到相应的等级啦。
            <br><strong>等级和等级分对应表</strong>
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_1.png`" style="width: 500px;">
        <p class="title">4.	主播等级在哪里看？</p>
        <p class="content">① <strong>手机端（需要升级到喜马拉雅最新版本6.3.27哦）</strong>
            <br>入口：「我的」页面右上角>点击进入「主播工作台」> 点击等级模块
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_2.jpg`" style="width: 500px;">
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_3.jpg`" style="width: 500px;">
        <p class="content">从入口点击进去，即可看到您的主播等级详情，包括您的等级分值、当前升级所需要的条件、解锁特权，点击右上角还可以查看升级攻略哟~</p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_4.jpg`" style="width: 500px;">
        <p class="content">②<strong>网页端</strong>
            <br>入口：主播工作台首页>查看等级
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_5.jpg`" style="width: 500px;">
        <p class="content">点击「查看等级」可查看您的等级详情：</p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_5.jpg`" style="width: 500px;">
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_6.jpg`" style="width: 500px;">
        <p class="title">5.	主播等级有什么用？</p>
        <p class="content">主播等级的作用可是大大的哦：
            <br>①解锁功能，获得资源倾斜
            <br>②获得精准指导和帮扶
            <br>③在同行压力和激励下不断进步</p>
        <p class="content"><strong>1） 解锁功能权限，获得资源倾斜</strong>
            <br>喜马拉雅会根据主播等级，匹配相应的功能权限，资源上也会倾斜向有潜力的主播。
            <br><br><strong>主播等级权益表</strong>
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_level_7.jpg`" style="width: 500px;">
        <p>以上为本期主播等级功能权益，更多特权会陆续开通，敬请期待哦​~</p>
        <p class="content"><strong>2）获得精准的指导和帮扶</strong>
            <br>喜马拉雅会根据主播当前的等级，评估成长状况，更精准提供相应的帮助和指导服务。
            <br><br>3） 同行的压力和激励
            一个人默默努力经常会软弱和疲倦，喜马拉雅有数十万主播与您一起为创作优质节目而努力，在等级体系中，找到自己在发展路线上的标杆和榜样，从他们的想法和做法中受到启发，让自己躺着也能进步哦</p>
        <p class="title">6.	如何提升主播等级？</p>
        <p class="content">会影响到您等级分的因素主要有2个：①累计节目收听的人数、②总共获得的收入。另外，平台资源使用也会对等级分有一点影响。以下方法可以有效提升您的等级。
            <br><br><strong>① 发布优质节目，保持稳定更新频率</strong>
            <br>优质节目是前提，保证有一定的节目数量和稳定的更新频率，为优秀主播快速升级和成长奠定基础。新手主播可以通过参加“全民朗读”，朗读文章来提升自己的技能，增长等级哦。
            <br><br><strong>②积极广节目，吸引更多人收听</strong>
            <br>节目收听人数越高，等级分值越高。需要注意的是，除了播放量，您还需要关注节目数据表现，完播率过低，不会被计入等级分哦。
            <br>主播等级可以自动生成分享海报，逼格满满，分享到朋友圈或者微博等自媒体，是吸引听众的利器哟。
            <br><br><strong>③ 培养粉丝的付费习惯</strong>
            收益越高，等级分越高。引导粉丝为您的内容创作付费，比如购买付费节目，直播送礼，为免费节目赞助打赏等，会提升您的收益，也能正向激励您创作更优质的内容。
            <br><br><strong>④ 申请绿色通道</strong>
            <br>在其他自媒体平台已有较高名气和粉丝量，认证时可申请名人名企通道，主播助手审核会酌情加分
            <br><br><strong>⑤ 爱惜平台资源</strong>
            <br>不要上传大量低质量的节目，滥用平台资源会提升您的成本评估，从而降低您的等级分值
            <br><br>以上是为您总结的几条升级建议，期待您在喜马拉雅获得提升和成长么么哒！
        </p>
        <p class="title">7.	我是新人主播，如何快速增加我的主播等级呢？</p>
        <p class="content">如果您是新手主播，您可以通过参加“全民朗读”，练习朗读文章，学习主播相关技能，来提升自己的主播等级喔。当主播等级达到V4，就可以在作品有声化平台参加海选试音，迎接更大的挑战了。
        </p>
        <p class="title">“全民朗读”参与步骤</p>
        <p class="content">第一步，打开喜马拉雅APP，进入“发现”页面。</p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_26.png`" style="width: 500px;border: 1px solid #eee;">
        <p class="content">第二步，在“发现”页面，点击进入“全民朗读”。</p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_27.png`" style="width: 500px;border: 1px solid #eee;">
        <p class="content">第三步，在“全民朗读”页面，您可以自由选择不同主题或作家的文章进行朗读。点击“读这篇”进入录制界面。</p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_28.png`" style="width: 500px;border: 1px solid #eee;">
        <p class="content">第四步，点击录音按钮，即可开始朗读，加油增长等级吧</p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_29.png`" style="width: 500px;border: 1px solid #eee;">
    </div>
</template>
<script>
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    },
    beforeMount() {

    }
  }
</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// AnchorLevelTips.vue?1d7b05be